import {
  Container,
  Row,
  TitleHighlight,
  HomeNewsLayoutCard,
  NavigationBlog,
} from "../../../../components";
import { PostItems } from "../../../../types/PostsList";
import styles from "./styles.module.scss";
import { NavigationTypes } from "../../../../types/HomeTypes";

interface PostsQueryResult {
  edges: Array<PostItems>;
  name: string;
  desc?: string | null;
  navigation: Array<NavigationTypes> | null;
  displayDescription: boolean | null;
}

const ListNews = ({
  edges,
  name,
  desc,
  navigation,
  displayDescription,
}: PostsQueryResult) => {
  return (
    <div className={styles.ListNews}>
      {navigation && <NavigationBlog items={navigation} />}

      <Container>
        {displayDescription != false && (
          <>
            <TitleHighlight
              style={{
                textTransform: "uppercase",
                fontSize: 28,
              }}
            >
              {name}
            </TitleHighlight>

            {desc != null && (
              <details>
                <summary>Descrição</summary>
                <h4 dangerouslySetInnerHTML={{ __html: desc || "" }} />
              </details>
            )}
          </>
        )}

        <Row>
          <div className={styles.CardsList}>
            <HomeNewsLayoutCard items={edges} />
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default ListNews;
